import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromAuth from '../auth/reducers';
import { AuthActions } from '../auth/actions';
import { AuthService } from '../services';
import { Observable } from 'rxjs';
import { CustomerActions } from '../actions';
import { User } from '@auth0/auth0-spa-js';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationFacade {
  private readonly store: Store<fromAuth.State> = inject(Store<fromAuth.State>);
  private readonly authService: AuthService = inject(AuthService);

  readonly isUserLoggedIn$: Observable<boolean> = this.store.pipe(select(fromAuth.selectIsAuthenticated));
  readonly loggedUser$: Observable<User | null> = this.store.pipe(select(fromAuth.selectUser));
  readonly accessToken$: Observable<string> = this.store.pipe(select(fromAuth.selectAccessToken));
  readonly isLoginInProcess$: Observable<boolean> = this.store.pipe(select(fromAuth.selectIsLoginInProcess));
  readonly isAuthenticated$: Observable<boolean> = this.store.pipe(select(fromAuth.selectIsAuthenticated));

  authorization(queryParameters?: Params): void {
    this.store.dispatch(AuthActions.logIn({url: '', queryParameters: queryParameters ?? {}}));
  }

  logout(skipRedirect: boolean = false): void {
    this.store.dispatch(CustomerActions.clearCompanyRoles());
    this.authService.logout(skipRedirect).subscribe();
  }

  getAuthenticatedCookie(): boolean {
    return this.authService.getAuthenticatedCookie();
  }

  selectIsUserLoggedIn(): Observable<boolean> {
    return this.isUserLoggedIn$;
  }
}
